// src/features/aiMatcher/aiMatcherApi.ts

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export type SiteLocation = {
  city?: string;
  state?: string;
  zip?: string;
  lat?: number;
  lng?: number;
};

export type ClinicalTrial = {
  nctId?: string;
  description?: string;
  briefSummary?: string;
  eligibilityCriteria?: string;
  healthyVolunteers?: boolean;
  sex?: string;
  minimumAge?: string;
  sponsorInfo?: { leadSponsor?: { name?: string } };
  site_location: SiteLocation[];
};

export interface MatchTrialsRequest {
  prompt: string;
  trials: ClinicalTrial[];
}

export interface MatchTrialsResponse {
  matches: {
    nctId: string;
    reason: string;
  }[];
}


export const aiMatcherApi = createApi({
  reducerPath: 'aiMatcherApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '', // same pattern as your existing APIs
  }),
  endpoints: (builder) => ({
    matchTrials: builder.mutation<MatchTrialsResponse, MatchTrialsRequest>({
      query: (body) => {
        console.log('RTK Query body →', body);
        return { 
          url: '/api/bcan/match-trials',
          method: 'POST',
          body,
        }
      },
    }),
  }),
});

export const {
  useMatchTrialsMutation,
} = aiMatcherApi;
